export default function generateAvatar(name) {
  return `https://ui-avatars.com/api/?background=0D8ABC&color=fff&&name=${name}`;
}
